/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const GET_CUSTOM_ROLES_LIMIT_BY_APP = 'appConfigTypes/GET_CUSTOM_ROLES_LIMIT_BY_APP';
export const GET_CUSTOM_ROLES_LIMIT_BY_APP_SUCCESS = 'appConfigTypes/GET_CUSTOM_ROLES_LIMIT_BY_APP_SUCCESS';
export const GET_CUSTOM_ROLES_LIMIT_BY_APP_FAILURE = 'appConfigTypes/GET_CUSTOM_ROLES_LIMIT_BY_APP_FAILURE';

export interface GetCustomRolesLimitAction {
  type: typeof GET_CUSTOM_ROLES_LIMIT_BY_APP;
  payload?:any;
}

export interface GetCustomRolesLimitSuccessAction {
  type: typeof GET_CUSTOM_ROLES_LIMIT_BY_APP_SUCCESS;
  payload?:any;
}

export interface GetCustomRolesLimitFailureAction {
  type: typeof GET_CUSTOM_ROLES_LIMIT_BY_APP_FAILURE;
  payload?:any;
}
